import { LoaderFunctionArgs, useLoaderData, useParams } from 'react-router-dom'
import { useIsAccountClosed } from '../../components/AppShell'
import { ReportsIndex, fetchReports } from '../../api/reports'
import { trackEvent } from '../../lib/config'
import { ButtonLink, Panel, PanelBody, PanelHeading } from '../../components/common'

function toChileanDate(isoDate: string): string {
  const [year, month, day] = isoDate.slice(0, 10).split('-')
  return `${day}-${month}-${year}`
}

export function loader({ params }: LoaderFunctionArgs): Promise<ReportsIndex> {
  return fetchReports(Number(params.healthCenterId), params.patientId as string)
}

export default function ReportsIndexPage() {
  const data = useLoaderData() as Awaited<ReturnType<typeof loader>>
  const closed = useIsAccountClosed()
  const params = useParams()
  const healthCenterId = Number(params.healthCenterId)
  const patientId = params.patientId as string

  return (
    <Panel>
      <PanelHeading>
        <b>
          <h1 style={{ textAlign: 'center' }}>{`Informes de ${data.patient.name ?? ''}`}</h1>
        </b>
      </PanelHeading>
      <PanelBody>
        <div className="text-center">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Descargar</th>
              </tr>
            </thead>
            <tbody>
              {data.reports.map((report, index) => (
                <tr key={report.id} data-testid={`row-${report.id}`}>
                  <th>{index + 1}</th>
                  <th>{toChileanDate(report.created_at)}</th>
                  <td>{report.type}</td>
                  <td>
                    <a
                      href={report.download_path}
                      onClick={() => trackEvent('Report Downloaded', { report_id: report.id }, { transport: 'sendBeacon' })}
                    >
                      Descarga
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <br />
        {!closed && data.reports_templates.map((template) => (
          <span key={template.id}>
            <ButtonLink
              to={`/health_centers/${healthCenterId}/patients/${patientId}/reports/new?report_template=${template.id}`}
              onClick={() => trackEvent('Report Template Selected', { template_id: template.id })}
            >
              {template.name}
            </ButtonLink>{' '}
          </span>
        ))}
      </PanelBody>
    </Panel>
  )
}
